import { render, staticRenderFns } from "./EditType.vue?vue&type=template&id=fd66ec9e&scoped=true&"
import script from "./EditType.vue?vue&type=script&lang=js&"
export * from "./EditType.vue?vue&type=script&lang=js&"
import style0 from "./EditType.vue?vue&type=style&index=0&id=fd66ec9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd66ec9e",
  null
  
)

export default component.exports